import {
    SETTINGS_FEATURE_FLAGS_ENABLE_RETAILCRM_UNIVERSAL_UI,
    SETTINGS_INTEGRATIONS_CRM_AMOCRM_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_AMOCRM_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_AMOCRM_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_BITRIX24_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_BITRIX24_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_BITRIX24_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_MINDBOX_DOMAIN_SLUG,
    SETTINGS_INTEGRATIONS_CRM_MINDBOX_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_MINDBOX_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CONSULTANT_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CRM_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_TRACKER_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_URL_SLUG,
    SETTINGS_INTEGRATIONS_DIRECT_AI_PRODUCT_SEARCH_TEXTS_SLUG,
    SETTINGS_INTEGRATIONS_GOODS_AI_PRODUCT_SEARCH_TEXTS_SLUG,
} from '../../constants';
import { type SettingsValue, useSettingsFactory } from './useSettingsFactory';

export type SettingsIntegrationAIProductTexts =
    | SettingsValue<typeof SETTINGS_INTEGRATIONS_DIRECT_AI_PRODUCT_SEARCH_TEXTS_SLUG>
    | SettingsValue<typeof SETTINGS_INTEGRATIONS_GOODS_AI_PRODUCT_SEARCH_TEXTS_SLUG>;

export const useSettingsIntegration = () =>
    useSettingsFactory({
        bitrix24Key: { path: SETTINGS_INTEGRATIONS_CRM_BITRIX24_KEY_SLUG },
        bitrix24IsEnabled: { path: SETTINGS_INTEGRATIONS_CRM_BITRIX24_IS_ENABLED_SLUG },
        bitrix24Url: { path: SETTINGS_INTEGRATIONS_CRM_BITRIX24_URL_SLUG },
        amocrmKey: { path: SETTINGS_INTEGRATIONS_CRM_AMOCRM_KEY_SLUG },
        amocrmIsEnabled: { path: SETTINGS_INTEGRATIONS_CRM_AMOCRM_IS_ENABLED_SLUG },
        amocrmUrl: { path: SETTINGS_INTEGRATIONS_CRM_AMOCRM_URL_SLUG },
        mindboxKey: { path: SETTINGS_INTEGRATIONS_CRM_MINDBOX_KEY_SLUG },
        mindboxIsEnabled: { path: SETTINGS_INTEGRATIONS_CRM_MINDBOX_IS_ENABLED_SLUG },
        mindboxDomain: { path: SETTINGS_INTEGRATIONS_CRM_MINDBOX_DOMAIN_SLUG },
        universalRetailCrmKey: { path: SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_KEY_SLUG },
        universalRetailCrmIsEnabled: { path: SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_IS_ENABLED_SLUG },
        universalRetailCrmUrl: { path: SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_URL_SLUG },
        universalRetailCrmCrmUrl: { path: SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CRM_URL_SLUG },
        universalRetailCrmConsultantEnabled: {
            path: SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CONSULTANT_ENABLED_SLUG,
        },
        universalRetailCrmTrackerEnabled: {
            path: SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_TRACKER_ENABLED_SLUG,
        },
        universalRetailCrmFeatureFlag: { path: SETTINGS_FEATURE_FLAGS_ENABLE_RETAILCRM_UNIVERSAL_UI },
        directAISearchProductTexts: { path: SETTINGS_INTEGRATIONS_DIRECT_AI_PRODUCT_SEARCH_TEXTS_SLUG },
        goodsAISearchProductTexts: { path: SETTINGS_INTEGRATIONS_GOODS_AI_PRODUCT_SEARCH_TEXTS_SLUG },
    });
